
export default function TemplateComponent({ component, hideText }) {
  const { type, parameters } = component;

  if (!parameters || parameters.length === 0) {
    return null;
  }

  const renderHeader = () => {
    return (
      <div className="space-y-1">
        {parameters.map((param, idx) => {
          if (param.type === "image" && (param.image?.link || param.image?.id)) {
            return param.image.link ? (
              <img
                key={idx}
                src={param.image.link}
                alt="Template header"
                className="w-full rounded-md max-h-48 object-cover"
              />
            ) : (
              <div key={idx} className="w-full h-32 bg-gray-100 dark:bg-slate-800 flex items-center justify-center rounded-md text-sm text-gray-500 border border-gray-200 dark:border-slate-700">
                📷 Image Attached
              </div>
            );
          }
          if (param.type === "video" && (param.video?.link || param.video?.id)) {
            return param.video.link ? (
              <video
                key={idx}
                controls
                className="w-full rounded-md max-h-48"
              >
                <source src={param.video.link} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <div key={idx} className="w-full h-32 bg-gray-100 dark:bg-slate-800 flex items-center justify-center rounded-md text-sm text-gray-500 border border-gray-200 dark:border-slate-700">
                🎥 Video Attached
              </div>
            );
          }
          if (param.type === "document" && (param.document?.link || param.document?.id)) {
            return param.document.link ? (
              <a
                key={idx}
                href={param.document.link}
                download
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 dark:text-blue-400 underline text-sm"
              >
                {param.document.filename || "Download Document"}
              </a>
            ) : (
              <div key={idx} className="flex items-center gap-2 p-2 bg-gray-50 dark:bg-slate-800 rounded-md border border-gray-200 dark:border-slate-700">
                <span className="text-xl">📎</span>
                <span className="text-sm font-medium text-gray-700 dark:text-slate-300 truncate">
                  {param.document.filename || "Document Attached"}
                </span>
              </div>
            );
          }
          return null;
        })}
      </div>
    );
  };

  const renderBody = () => {
    const textParams = parameters.filter((p) => p.type === "text");
    return (
      <div className="space-y-1">
        {textParams.map((param, idx) => (
          <p key={idx} className="text-sm break-words">
            {param.text}
          </p>
        ))}
      </div>
    );
  };

  const renderFooter = () => {
    const textParams = parameters.filter((p) => p.type === "text");
    return (
      <div className="text-xs text-gray-600 dark:text-slate-400 border-t border-gray-200 dark:border-slate-700 pt-1">
        {textParams.map((param, idx) => (
          <p key={idx}>{param.text}</p>
        ))}
      </div>
    );
  };

  const renderButtons = () => {
    return (
      <div className="space-y-1 mt-2">
        {parameters.map((param, idx) => {
          if (param.type !== "button") return null;
          return (
            <button
              key={idx}
              className="w-full px-3 py-2 text-sm bg-gray-200 dark:bg-slate-700 hover:bg-gray-300 dark:hover:bg-slate-600 rounded transition-colors"
              disabled
            >
              {param.button?.title || "Button"}
            </button>
          );
        })}
      </div>
    );
  };

  switch (type) {
    case "header":
      return <div>{renderHeader()}</div>;
    case "body":
      return hideText ? null : <div>{renderBody()}</div>;
    case "footer":
      return hideText ? null : <div>{renderFooter()}</div>;
    case "buttons":
      return hideText ? null : <div>{renderButtons()}</div>;
    default:
      return null;
  }
}
